<template>
  <div>
    <AccessHandler
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <MiniCRM />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MiniCRM from "./MiniCrm.vue";
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import { UserRoles as Roles } from "@/Domain/UserRoles";
import { ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";

const roleGroups = [
  {
    roles: [
      Roles.ROLE_IN_HOUSE_MIS_MANAGER,
      Roles.ROLE_MIS,
      Roles.ROLE_RC_PRIMARY,
    ],
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>
